import { render, staticRenderFns } from "./ModalPopup.vue?vue&type=template&id=45e88d02&scoped=true"
import script from "./ModalPopup.vue?vue&type=script&lang=js"
export * from "./ModalPopup.vue?vue&type=script&lang=js"
import style0 from "./ModalPopup.vue?vue&type=style&index=0&id=45e88d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e88d02",
  null
  
)

export default component.exports